import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({providedIn: 'root'})
export class PaginatorIntlService extends MatPaginatorIntl {
  itemsPerPageLabel = 'Items per page';
  nextPageLabel     = 'Next page';
  previousPageLabel = 'Previous page';
  _translocoService: TranslocoService

    constructor() {
      super();
    } 

  getRangeLabel = function (page, pageSize, length) {
    const of = this._translocoService ? this._translocoService.translate('paginator.of'): 'of';
    if (length === 0 || pageSize === 0) {
      return '0 ' + of + ' ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    //If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
  };

  injectTranslateService(translocoService: TranslocoService) {
      this._translocoService = translocoService;
      this._translocoService.langChanges$.subscribe((lang) =>  {
        this._translocoService.load(lang).subscribe(() => {
          this.translateLabels();
        });
      });
  }

  translateLabels() {
        this.itemsPerPageLabel = this._translocoService.translate('paginator.items-per-page');
        this.nextPageLabel = this._translocoService.translate('paginator.next-page');
        this.previousPageLabel = this._translocoService.translate('paginator.previous-page');
        this.changes.next();
  }
}